var _style, _path, _path2, _path3, _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoBlanco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 453 147",
    style: {
      enableBackground: "new 0 0 453 147"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{enable-background:new    ;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13,138.6c8.9-6.7,18.4-12.1,28.5-16.6c24.4-10.9,50.1-16.3,76.6-18.3c21.5-1.6,42.9-1.1,64.4,0.1 c20.4,1.2,40.7,3,61,3.9c17.3,0.8,34.7,1.2,52,1c16.1-0.2,32.2-1.7,48-5.2c23.8-5.4,46.1-14.5,66.9-27.3 c9.6-5.9,18.7-12.6,27.1-20.2c0.6-0.5,1.2-1,1.9-1.6c0.2,0.1,0.3,0.3,0.5,0.4c-0.7,0.9-1.4,1.7-2.1,2.6 c-14.2,16.5-31.6,28.7-51,38.2c-12,5.9-24.5,10.3-37.2,14.3c-27.7,8.7-56.2,11.9-85,11.3c-21.8-0.4-43.5-1.9-65.3-2.9 c-22.1-1.1-44.3-2.6-66.4-3.2c-19.9-0.5-39.8,0.7-59.5,4.2c-20.1,3.5-39.5,9.3-57.9,18.2C14.6,138,13.8,138.3,13,138.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.2,137.9c7.3-2.5,14.5-5.1,21.8-7.4c13.1-4.2,26.7-6.4,40.3-7.4c13.4-1,26.9-1.7,40.3-1.3 c18.7,0.5,37.4,2,56.1,3.1c16.8,1,33.7,2.4,50.5,3.2c11.2,0.5,22.4,0.6,33.6,0.3c15.9-0.5,31.6-2.1,47.2-5.6 c5.4-1.2,10.7-2.5,16.2-3.4c-5.7,2.1-11.4,4.2-17.2,6.2c-13,4.4-26.4,6.8-39.9,8.2c-8.7,0.9-17.5,1.6-26.3,1.7 c-13.4,0.1-26.7,0-40.1-0.7c-17.7-0.9-35.4-2.6-53-3.9c-22.4-1.6-44.9-2.7-67.4-1.9c-17,0.6-33.8,2.7-50.3,6.6 c-3.9,0.9-7.7,2-11.5,3C37.3,138.3,37.3,138.1,37.2,137.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M436.4,42.6c-4.7,4.6-9.1,9.5-14,13.9c-13.9,12.3-30,21-47,28.2c-11.5,4.9-23.4,8.7-35.6,11 c-11.2,2.2-22.6,3.7-33.9,4.6c-12.5,0.9-25,0.7-37.5,0.9c-0.8,0-1.7-0.1-2.5-0.6c4.9-0.2,9.8-0.4,14.7-0.7c17.9-1,35.8-2.6,53.4-6.4 c22.8-4.9,44.4-13.2,64.7-24.7c13-7.3,25.2-15.8,36-26.1c0.3-0.3,0.7-0.6,1.1-0.9C436,42.1,436.2,42.4,436.4,42.6z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M84.9,25.8h13.2c2.5,0,4.4,0.3,5.6,0.9c1.3,0.6,2.2,1.5,2.9,2.6c0.7,1.2,1,2.6,1,4.3c0,2.2-0.6,4.1-1.8,5.8 s-2.7,2.9-4.5,3.7c-1.8,0.7-4.3,1.1-7.4,1.1h-4l-2.3,10.7h-9.1L84.9,25.8z M91.2,38.4h3c1.4,0,2.6-0.4,3.5-1.2s1.4-1.8,1.4-3 c0-1.7-0.9-2.6-2.8-2.6h-3.5L91.2,38.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M132.5,54.9h-8.8l-0.4-4.8h-9.5l-2.3,4.8h-9.7l16.4-29.1h9.6L132.5,54.9z M122.7,43.9l-0.9-10.6h-0.1l-5,10.6 H122.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M169.8,25.8l-6.2,29.1h-8.4L147.9,38h-0.1l-3.6,16.9h-8.5l6.2-29.1h8.4l7.2,16.9h0.1l3.6-16.9 C161.2,25.8,169.8,25.8,169.8,25.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M197.5,54.9h-8.8l-0.4-4.8h-9.5l-2.3,4.8h-9.7l16.4-29.1h9.6L197.5,54.9z M187.8,43.9l-0.9-10.6h-0.1l-5,10.6 H187.8z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M257.3,16.1l-8.4,38.8h-10l7.2-29.6h-0.2l-14.4,29.6h-8.8L221,25.3l0,0l-5.6,29.6h-10l8.3-38.8h14.6l1.5,24.6 h0.1l12.3-24.6C242.2,16.1,257.3,16.1,257.3,16.1z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M284.5,54.9h-8.8l-0.4-4.8h-9.5l-2.3,4.8h-9.7l16.4-29.1h9.6L284.5,54.9z M274.7,43.9l-0.9-10.6h-0.1l-5,10.6 H274.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M293.9,25.8h16.5c2.9,0,4.9,0.7,6.3,2.2c1.3,1.5,2,3.3,2,5.4c0,2.3-0.7,4.3-2.1,6s-3.6,2.8-6.7,3.3 c1.8,1.5,4,5.6,6.5,12.2H307c-0.8-2.1-1.7-4.4-2.8-6.9s-1.9-3.9-2.4-4.3c-0.5-0.4-1.2-0.6-2-0.6h-0.5l-2.5,11.8h-9L293.9,25.8z  M300.5,37.6h1.7c2.9,0,4.7-0.1,5.5-0.4c0.8-0.3,1.5-0.7,1.9-1.3s0.6-1.2,0.6-1.8c0-0.7-0.2-1.3-0.7-1.7c-0.5-0.4-1.6-0.6-3.2-0.6 h-4.6L300.5,37.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M335.1,25.8l-6.2,29.1h-9.1l6.2-29.1C326,25.8,335.1,25.8,335.1,25.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M369.2,25.8L363,54.9h-8.4L347.3,38h-0.1l-3.6,16.9h-8.5l6.2-29.1h8.4l7.2,16.9h0.1l3.7-16.9 C360.7,25.8,369.2,25.8,369.2,25.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M399,25.8l-1.3,6.2h-14.8l-1,4.6h14.2l-1.3,5.9h-14.2l-1.2,5.7h16l-1.4,6.6h-25l6.2-29.1H399V25.8z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M77.2,66.9H92c2.6,0,4.4,0.7,5.6,2s1.8,2.9,1.8,4.8c0,2-0.6,3.8-1.9,5.3s-3.3,2.5-6,2.9 c1.6,1.3,3.6,5,5.8,10.9h-8.5c-0.7-1.9-1.5-3.9-2.5-6.2c-1-2.2-1.7-3.5-2.2-3.9s-1.1-0.5-1.8-0.5H82l-2.2,10.6h-8.1L77.2,66.9z  M83.1,77.5h1.5c2.6,0,4.2-0.1,5-0.4c0.8-0.2,1.3-0.6,1.7-1.2c0.4-0.6,0.5-1.1,0.5-1.6c0-0.7-0.2-1.2-0.7-1.6 c-0.4-0.4-1.4-0.6-2.9-0.6h-4.1L83.1,77.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M126.7,66.9l-1.2,5.6h-13.2l-0.9,4.1h12.7l-1.2,5.3h-12.7l-1.1,5.1h14.3l-1.3,5.9H99.9l5.5-26H126.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M131.7,66.9h11.8c2.2,0,3.9,0.3,5,0.8s2,1.3,2.6,2.3s0.9,2.3,0.9,3.8c0,2-0.5,3.7-1.6,5.2s-2.4,2.6-4,3.3 s-3.8,1-6.7,1h-3.6l-2,9.6H126L131.7,66.9z M137.4,78.2h2.7c1.3,0,2.3-0.4,3.1-1.1s1.2-1.6,1.2-2.7c0-1.6-0.8-2.3-2.5-2.3h-3.2 L137.4,78.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M174.3,92.9h-7.9l-0.4-4.3h-8.5l-2,4.3h-8.7l14.7-26h8.6L174.3,92.9z M165.5,83.1l-0.8-9.5h-0.1l-4.5,9.5 H165.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M191.3,66.9l-5.6,26h-8.1l5.6-26H191.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M196.9,66.9h14.8c2.6,0,4.4,0.7,5.6,2c1.2,1.3,1.8,2.9,1.8,4.8c0,2-0.6,3.8-1.9,5.3s-3.3,2.5-6,2.9 c1.6,1.3,3.6,5,5.8,10.9h-8.5c-0.7-1.9-1.5-3.9-2.5-6.2c-1-2.2-1.7-3.5-2.2-3.9s-1.1-0.5-1.8-0.5h-0.4l-2.2,10.6h-8.1L196.9,66.9z  M202.7,77.5h1.5c2.6,0,4.2-0.1,5-0.4c0.8-0.2,1.3-0.6,1.7-1.2s0.5-1.1,0.5-1.6c0-0.7-0.2-1.2-0.7-1.6c-0.4-0.4-1.4-0.6-2.9-0.6 h-4.1L202.7,77.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlanco);
export default __webpack_public_path__ + "static/media/logo_Blanco.ea9aa08cb67c0ea3e3062bdef85b3d90.svg";
export { ForwardRef as ReactComponent };